module.exports = __webpack_public_path__ + "img/head-paso1.63c64eb1.svg";